import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'

import { accountsService } from 'src/services/accounts.service'
import { ICancelRemovalDto } from 'src/types'

import { QUERY_KEYS } from 'src/constants'

const useCancelAccountUsersRemove = () => {
  const queryClient = useQueryClient()
  const { accountId } = useParams()

  return useMutation(
    [QUERY_KEYS.ACCOUNT_USERS],
    (dto: ICancelRemovalDto) => accountsService.cancelRemove(dto),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([QUERY_KEYS.ACCOUNT_USERS, accountId])
      },
    },
  )
}

export { useCancelAccountUsersRemove }
